<app-dialog-layout class="madar--v2 bg-white">
  <app-state-section [state]="sectionState">
    <div class="pb-4 flex align-center justify-center">
      <img src="../../../assets/images/outline-tick-circle.svg" alt="tick-circle" />
    </div>
    <div class="text-center">
      <h5 class="h5 weight-semibold text-accent mb-3">{{ "sharedFeatures.FleetSurveyTitle" | translate }}</h5>
      <div class="mb-5 h6">
        <p class="mb-3">{{ "sharedFeatures.ThankYouMessage" | translate }}</p>
        <p class="mb-0">{{ "sharedFeatures.RatingMessage" | translate }}</p>
      </div>
    </div>
    <form [formGroup]="form">
      <div class="flex align-center justify-center mb-3">
        <div *ngFor="let rate of fleetSurveyRating | enumToArray" class="mx-8 text-center cursor-pointer" (click)="selectRating(rate.value)">
          <img
            [src]="'../../../assets/images/'+ (form.controls.rating.value === rate.value ? rate.key : ('outline-'+ rate.key) ) + '-face.svg' | lowercase"
            [alt]="rate.key"
          />
          <p class="text-900 small">{{ 'sharedFeatures.'+ rate.key | translate }}</p>
        </div>
      </div>
      <div class="mb-8">
        <mat-label class="d-block w-100" id="">{{ "sharedFeatures.Notes" | translate }}</mat-label>
        <mat-form-field appearance="outline" class="w-100">
          <textarea matInput type="text" [placeholder]="'Placeholder.WriteReason' | translate" formControlName="notes"></textarea>
        </mat-form-field>
      </div>
      <button mat-flat-button class="w-100 bg-primary text-white" [disabled]="form.invalid" (click)="submitFleetSurvey()">
        {{ "sharedFeatures.Submit" | translate }}
      </button>
    </form>
  </app-state-section>
</app-dialog-layout>
